// extracted by mini-css-extract-plugin
module.exports = {"certificationCard":"style-module--certificationCard--18pr3","imageContainer":"style-module--imageContainer--3Tui5","imageStyle":"style-module--imageStyle--3tGQK"};